<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12 class="indigo lighten-5">
      <v-data-table
        select-all
        :headers="headers"
        :items="dias_visualizacao"
        :hide-actions="true"
        v-model="selected"
        expand
        class="mx-2 deep-purple lighten-5"
      >
        <template v-slot:items="lista">
          <tr style="border: 1px solid #ede7f6">
            <td>
              <v-checkbox
                v-model="lista.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td @click="expansor(lista.item.id)">
              {{ lista.item.dia_semana }}
            </td>
            <td @click="expansor(lista.item.id)">{{ lista.item.dia }}</td>
            <td @click="expansor(lista.item.id)" v-if="!selectedCreditor">
              [{{ lista.item.creditors.join(", ") }}]
            </td>
            <td @click="expansor(lista.item.id)">
              {{ lista.item.budget | numeral("$0,0.00") }}
            </td>
            <td @click="expansor(lista.item.id)">{{ lista.item.goal }}</td>
            <td @click="expansor(lista.item.id)">{{ lista.item.changed_by }}</td>
            <td @click="expansor(lista.item.id)">
              {{ formatar_hora(lista.item.last_event) }}
            </td>
            <td @click="expansor(lista.item.id)">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </td>
            <td @click="expansor(lista.item.id)">
              <div :ref="'icon_up_' + lista.item.id" style="display: none">
                <v-icon color="deep-purple darken-1">keyboard_arrow_up</v-icon>
              </div>
              <div :ref="'icon_down_' + lista.item.id">
                <v-icon color="deep-purple darken-1"
                  >keyboard_arrow_down</v-icon
                >
              </div>
            </td>
          </tr>
          <tr
            v-for="dia in filtroList(lista.item.lista_dias)"
            v-bind:key="dia.id"
            :ref="lista.item.id"
            style="display: none"
            v-bind:class="[dia.removed ? 'arquivado' : 'ativo']"
          >
            <td colspan="3" class="deep-purple lighten-5" />
            <td v-if="!selectedCreditor">
              {{ getNameCreditor(dia.creditor_id) }}
            </td>
            <td>
              {{ dia.budget | numeral("$0,0.00") }} ({{
                dia.type | forecastType
              }})
            </td>
            <td>{{ dia.goal }}</td>
            <td>{{ dia.last_updated_by }}</td>
            <td>{{ formatar_hora(dia.last_event) }}</td>
            <td>
              <v-menu offset-y>
                <v-icon color="deep-purple darken-1" slot="activator"
                  >more_vert</v-icon
                >
                <v-list class="">
                  <v-list-tile @click="handleRevisao(dia)" v-if="!dia.removed"
                    >Revisar</v-list-tile
                  >
                  <v-list-tile @click="mostrar_historico(dia)"
                    >Histórico</v-list-tile
                  >
                  <v-list-tile
                    @click="perguntar_arquivar(dia)"
                    v-if="!dia.removed"
                    >Arquivar</v-list-tile
                  >
                  <v-list-tile v-if="lista.item.day >= today" @click="orcamentoAdicional(lista.item)">
                    Orçamento adicional
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <v-dialog
      v-model="openDialog"
      min-height="500px"
      :max-width="item_edicao.type === 'LEMMIT_TREATMENT' ? '300px' : '1000px'"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :persistent="true"
    >
      <EditForecastHistoryModal
        v-if="openDialog"
        :dia_selecionado="item_edicao"
        :esperar="esperar"
        @incluir_revisao="incluir_revisao"
        @fechar="openDialog = false"
      />
    </v-dialog>

    <v-dialog
      v-model="dialogArquivar"
      max-width="500px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :persistent="true"
    >
      <v-card>
        <v-card-title class="headline deep-purple white--text" primary-title>
          Arquivar
        </v-card-title>
        <v-card-text>
          <h3>{{ title }}</h3>
          <p>
            {{ text }}
          </p>
        </v-card-text>
        <v-divider class="deep-purple" />
        <v-card-actions class="py-2">
          <v-btn flat color="primary" @click="dialogArquivar = false"
            >Fechar</v-btn
          >
          <v-spacer />
          <v-btn
            color="deep-purple"
            dark
            @click="arquivar_orcamento"
            :disabled="esperar"
            >Arquivar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogHistorico"
      max-width="800px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :persistent="true"
    >
      <v-card>
        <v-layout>
          <v-card-title class="headline">
            <strong class="headline deep-purple--text"
              >Histórico ({{ item_historico | forecastType }})
            </strong>
          </v-card-title>
        </v-layout>
        <v-divider class="ma-0" />
        <v-flex xs12 sm11 justify-self-center>
          <v-data-table
            :headers="historico_headers"
            :items="item_historico.history"
            :hide-actions="true"
            expand
          >
            <template v-slot:items="history">
              <tr>
                <td v-if="history.item.forecast_removed">Arquivado</td>
                <td v-else />
                <td>{{ history.item.budget | numeral("$0,0.00") }}</td>
                <td v-if="item_historico.type !== 'LEMMIT_TREATMENT'">
                  {{ history.item.goal }}
                </td>
                <td>{{ history.item.created_by }}</td>
                <td class="text-no-wrap">{{ formatar_hora(new Date(history.item.created_at)) }}</td>
                <td class="text-no-wrap">{{ history.item.type === 'BASAL' ? 'Orçamento Base' : 'Orçamento Adicional' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-divider class="ma-0" />
        <v-card-actions class="py-2">
          <v-spacer />
          <v-btn flat color="primary" @click="dialogHistorico = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import store from "@/store";
import EditForecastHistoryModal from "@/views/administration/forecast_components/EditForecastHistoryModal";

export default {
  props: [
    "dias_orcados",
    "filed",
    "ano_mes",
    "esperar",
    "credores",
    "selectedCreditor",
  ],
  components: {
    EditForecastHistoryModal,
  },
  data() {
    return {
      text: "",
      title: "",
      selected: [],
      dias_semana_pt: [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
      ],
      openDialog: false,
      item_edicao: "",
      item_historico: "",
      dialogArquivar: false,
      item_arquivar: "",
      dialogHistorico: false,
      today: new Date().toISOString().split('T')[0],
    };
  },
  computed: {
    dias_visualizacao: function () {
      if (this.dias_orcados.length === 0) {
        return [];
      } else {
        const dias_agrupados = this.filtroList(this.dias_orcados).reduce(
          (acc, dia) => {
            const periodo = new Date(dia.day + "T00:00:00");
            dia.dia_semana = this.dias_semana_pt[periodo.getDay()];
            dia.dia =
              periodo.getDate() < 10
                ? "0" + periodo.getDate()
                : periodo.getDate();
            dia.budget = parseFloat(dia.budget);
            dia.goal = parseInt(dia.goal);
            dia.last_event =
              dia.updated_at !== null
                ? new Date(dia.updated_at)
                : new Date(dia.created_at);

            (acc[dia["day"]] = acc[dia["day"]] || []).push(dia);

            return acc;
          },
          []
        );

        const dias_tratados = Object.keys(dias_agrupados).map((dia_grupo) => {
          const base = dias_agrupados[dia_grupo][0];
          const somas = dias_agrupados[dia_grupo].reduce(
            (acc, dia) => {
              const changed_by =
                "[" +
                (dia.last_updated_by !== null
                  ? dia.last_updated_by.split(" ")[0]
                  : "-") +
                "] ";
              const creditors = [this.getNameCreditor(dia.creditor_id)];

              return {
                creditors: acc.creditors.includes(creditors)
                  ? acc.creditors
                  : [...new Set(acc.creditors.concat(creditors))],
                budget: acc.budget + dia.budget,
                goal: acc.goal + dia.goal,
                changed_by: acc.changed_by.includes(changed_by)
                  ? acc.changed_by
                  : acc.changed_by + changed_by,
                last_event:
                  dia.last_event.getTime() > acc.last_event.getTime()
                    ? dia.last_event
                    : acc.last_event,
              };
            },
            {
              creditors: [],
              budget: 0.0,
              goal: 0,
              changed_by: [],
              last_event: new Date(0),
            }
          );

          return {
            id: "soma_" + base.id,
            day: dia_grupo,
            dia: base.dia,
            dia_semana: base.dia_semana,
            creditors: somas.creditors,
            goal: somas.goal,
            last_event: somas.last_event,
            changed_by: somas.changed_by,
            budget: somas.budget,
            lista_dias: dias_agrupados[dia_grupo],
          };
        });

        return dias_tratados;
      }
    },
    headers() {
      let headers = [
        {
          text: "Dia da semana",
          value: "dia_semana",
          sortable: false,
          width: "10%",
        },
        { text: "Dia", value: "dia", width: "10%" },
      ];

      if (!this.selectedCreditor) {
        headers.push({ text: "Credor", value: "creditors", width: "25%" });
      }

      headers.push({ text: "Orçamento", value: "budget", width: "15%" });
      headers.push({ text: "Produção", value: "goal", width: "15%" });
      headers.push({ text: "Revisão por", value: "changed_by", width: "20%" });
      headers.push({
        text: "Última alteração",
        value: "last_event",
        width: "15%",
      });
      headers.push({ text: "", value: "ações", sortable: false, width: "5%" });
      headers.push({
        text: "",
        value: "expansor",
        sortable: false,
        width: "5%",
      });

      return headers;
    },
    historico_headers() {
      var historico_headers = [{ text: "", value: "expaço" }];
      if (!this.selectedCreditor) {
        historico_headers.push({ text: "Credor", value: "creditors" });
      }
      historico_headers.push({ text: "Orçamento", value: "budget" });

      this.item_historico.type !== "LEMMIT_TREATMENT" &&
        historico_headers.push({ text: "Produção", value: "goal" });

      historico_headers.push({ text: "Revisão por", value: "created_by" });
      historico_headers.push({ text: "Data", value: "created_at" });
      historico_headers.push({ text: "Tipo do valor", value: "type" });
      return historico_headers;
    },
  },
  watch: {
    selected() {
      this.$emit("totalSelected", this.selected.length);
    },
  },
  methods: {
    filtroList(dias) {
      return dias.filter((d) => {
        if (this.filed || !d.removed) return true;
        return false;
      });
    },
    clearAllSelected() {
      this.selected = [];
    },
    toFileAllSelected() {
      this.title = "Tem certeza que deseja arquivar esses dias?";
      this.text =
        "Isso vai torná-los inativo e zerar seus valores para fins de cálculo (não pode ser desfeito)";
      this.dialogArquivar = true;
    },
    formatar_hora: function (dataHora) {
      return new Date(
        dataHora.valueOf() - dataHora.getTimezoneOffset() * 60000
      ).toLocaleString();
    },
    handleRevisao(item) {
      this.item_edicao = item;
      this.openDialog = true;
    },
    mostrar_historico(item) {
      this.item_historico = item;
      this.dialogHistorico = true;
    },
    incluir_revisao(revisao) {
      const currentUser = store.getters.getLoggedUser;
      const alteracoes = {
        forecast_id: this.item_edicao.id,
        budget: revisao.budget,
        goal: revisao.goal,
        created_by: currentUser.name,
      };
      this.$emit("incluir_revisao", alteracoes, this.item_edicao.id);
      this.openDialog = false;
    },
    expansor(id) {
      const rows = this.$refs[id];
      const estado = rows[0].style.display;

      if (estado === "none") {
        rows.map((r) => {
          r.style.display = "table-row";
        });
        this.$refs["icon_up_" + id].style.display = "block";
        this.$refs["icon_down_" + id].style.display = "none";
      } else {
        rows.map((r) => {
          r.style.display = "none";
        });
        this.$refs["icon_up_" + id].style.display = "none";
        this.$refs["icon_down_" + id].style.display = "block";
      }
    },
    perguntar_arquivar(dia) {
      this.title = "Tem certeza que deseja arquivar esse dia?";
      this.text =
        "Isso vai torná-lo inativo e zerar seus valores para fins de cálculo (não pode ser desfeito)";
      this.item_arquivar = dia;
      this.dialogArquivar = true;
    },
    arquivar_orcamento() {
      let msm = "";
      if (this.item_arquivar) {
        this.$emit("arquivar_orcamento", this.item_arquivar.id);
        this.item_arquivar = "";
        msm = "Orçamento arquivado com sucesso!";
      } else {
        this.selected.forEach((item) => {
          item.lista_dias.forEach((dia) => {
            if (!dia.removed) this.$emit("arquivar_orcamento", dia.id);
          });
        });
        this.clearAllSelected();
        msm = "Orçamentos arquivados com sucesso!";
      }
      this.$store.commit("showSnackbar", msm);
      this.dialogArquivar = false;
    },
    orcamentoAdicional(initiative) {
      this.$emit("orcamentoAdicional", initiative);
    },
    getNameCreditor(id) {
      if (!id) return "-";
      if (!this.credores.length) return "-";
      let creditor = this.credores.find((c) => c.creditor_id == id);
      return creditor && creditor.name ? creditor.name : "-";
    },
  },
};
</script>

<style scoped>
.arquivado {
  border: 3px solid #ede7f6;
  text-decoration: line-through;
}
.ativo {
  border: 3px solid #ede7f6;
}
</style>
